import React from 'react';
import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import { isOnline } from '../../utils/environment';
import { Error } from './Error';
import { withRouter } from 'next/router';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //reset previous error when navigating
        if (this.state.hasError && nextProps.router.asPath !== this.props.router.asPath) {
            this.setState({
                hasError: false,
            });
        }
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true });
        Sentry.captureException(error);
    }

    render() {
        if (this.state.hasError) {
            const Component = this.props.errorComponent || Error;

            return <Component pathname={this.props.router.asPath} isNetworkOnline={isOnline()} />;
        }

        return this.props.children;
    }
}

ErrorBoundary.propTypes = {
    errorComponent: PropTypes.func,
    router: PropTypes.object,
};

export default withRouter(ErrorBoundary);
